module.exports = "/images/11403a816c6f0c51f9becd9c3296fb72.jpg";